module.exports = __webpack_public_path__ + "img/slogan.bdabbf4d.svg";